import React from 'react';
import { useSnackbar } from '@components/Provider';
import Loading from '@components/Loading';
import {
  useRequestResetPasswordMutation,
  CapaErrorCode,
  CapaServiceType
} from '@generated/graphql';
import { STORAGE_ACTION, getStorageItem } from '@utils/storage';
import RequestPasswordPresenter from './RequestPasswordPresenter';
import { SignInForm } from './types';
import CommonLayout from '@routes/Common/CommonLayout';

const RequestPasswordContainer = () => {
  const isGhost = getStorageItem(STORAGE_ACTION.IS_GHOST_CLIENT);
  const { enqueueSnackbar } = useSnackbar();
  const [
    sendClientTempPassword,
    { loading }
  ] = useRequestResetPasswordMutation();

  const onSubmit = (req: SignInForm) => {
    if (isGhost && isGhost === 'true') return;
    sendClientTempPassword({
      variables: {
        input: {
          email: req.email,
          service: CapaServiceType.Quotation
        }
      }
    }).then((resp) => {
      if (resp.data?.requestResetPassword.result === CapaErrorCode.Success) {
        enqueueSnackbar(
          '임시 비밀번호를 발송했습니다. 이메일을 확인해주세요.',
          { variant: 'success' }
        );
      } else if (
        resp.data?.requestResetPassword.result === CapaErrorCode.UserNotFound
      ) {
        enqueueSnackbar(`가입되지 않은 이메일입니다.`, {
          variant: 'error'
        });
      } else {
        enqueueSnackbar(
          '이메일 주소를 다시 확인해주세요 오류가 반복되면 관리자에게 문의해주세요 ',
          { variant: 'error' }
        );
      }
    });
  };

  return (
    <CommonLayout gnbTabs={<></>} fullHeight>
      <Loading open={loading} />
      <RequestPasswordPresenter onSubmit={onSubmit} />
    </CommonLayout>
  );
};

export default RequestPasswordContainer;
